import { ResellerAgreementStatus } from '../../../../types/flyout'
import type { ResaleAuthorizationsResellerAgreements } from '../../../../types/resaleAuthorization'

export const getMicrosoftStatus = (status?: ResellerAgreementStatus) => {
  switch (status) {
    case ResellerAgreementStatus.OFFER_CREATION_FAILED:
      return 'Failed'
    case ResellerAgreementStatus.OFFER_PURCHASE_COMPLETE:
      return 'Pending account configuration'
    case ResellerAgreementStatus.OFFER_TERMS_ACCEPTED_BUYER:
      return 'Pending purchase'
    case ResellerAgreementStatus.OFFER_ACCEPTED:
      return 'Accepted'
    case ResellerAgreementStatus.OFFER_EXTENDED_TO_BUYER:
      return 'Extended to buyer'
    case ResellerAgreementStatus.OFFER_VIEWED_RESELLER:
      return 'Viewed by reseller'
    case ResellerAgreementStatus.OFFER_RESTRICTION_IN_PROGRESS:
      return 'Deactivation in progress'
    case ResellerAgreementStatus.OFFER_RESTRICTED:
      return 'Deactivated'
    case ResellerAgreementStatus.OFFER_EXPIRED:
      return 'Expired'
  }
}

export const getDeleteResellerDisabledTooltip = (
  agreement: ResaleAuthorizationsResellerAgreements | undefined,
  cloudType?: string
): string => {
  if (agreement?.draft) {
    return 'Draft offers can be deleted.'
  }
  switch (agreement?.status) {
    case ResellerAgreementStatus.EXPIRED:
      return 'Ended authorization cannot be deleted.'
    case ResellerAgreementStatus.IN_PROGRESS:
      return 'In progress authorization cannot be deleted.'
    case ResellerAgreementStatus.DEACATIVATED:
      return 'Deactivated authorization cannot be deleted.'
    case ResellerAgreementStatus.ACTIVE:
      return 'Active authorization cannot be deleted.'
    case ResellerAgreementStatus.CHANNEL_OFFER_ACCEPTED:
      return 'Completed authorization cannot be deleted.'
    case ResellerAgreementStatus.RESTRICTED:
      return 'Deactivated authorization cannot be deleted.'
    case ResellerAgreementStatus.DEACATIVATION_IN_PROGRESS:
      return 'Deactivation in progress authorization cannot be deleted.'
    case ResellerAgreementStatus.PENDING:
      return 'Pending authorization cannot be deleted.'
    default:
      return `This authorization cannot be deleted in its current status.`
  }
}

export const RESALE_AUTH_REVAMP_CLONE_ALLOWED_STATUSES: ResellerAgreementStatus[] =
  [
    ResellerAgreementStatus.ACTIVE,
    ResellerAgreementStatus.FAILED,
    ResellerAgreementStatus.RESTRICTED,
    ResellerAgreementStatus.EXPIRED,
    ResellerAgreementStatus.COMPLETED,
    ResellerAgreementStatus.IN_PROGRESS,
  ]

export const permissionMessageString =
  'This action is disabled because you have read-only access'
